import "./App.css";
import LayoutIndex from "./presentation/layout";

import React, { useEffect } from "react";
import { Provider, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import store from "./data/redux/store";
import { createBrowserHistory } from "history";
import RouteIndex from "./routes/routes";
import { CustomLoaderFullScreen } from "./presentation/components/main_comps/custom_loader_screen";

function App() {
  const history = createBrowserHistory();
  const isFullScreenLoading = useSelector(
    (state) => state.loaderSlice.isFullScreenLoading
  );

  return (
    <SnackbarProvider
      maxSnack={1}
      autoHideDuration={3000}
      auto
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {isFullScreenLoading && <CustomLoaderFullScreen />}
      <BrowserRouter history={history}>
        <LayoutIndex isAuthenticated={true}>
          <RouteIndex />
        </LayoutIndex>
      </BrowserRouter>
    </SnackbarProvider>
  );
}

export default App;
